import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface AuthShellProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  brandTitle?: string;
  brandSubtitle?: string;
  showHighlights?: boolean;
  centerContent?: boolean;
}

export default function AuthShell({
  title,
  subtitle,
  children,
  brandTitle = "انضم كمقدم خدمة",
  brandSubtitle = "سجّل شركتك وابدأ استقبال الطلبات",
  showHighlights = true,
  centerContent = false,
}: AuthShellProps) {
  return (
    <div dir="rtl" className="flex min-h-screen w-full">
      {/* Brand panel (right in RTL) */}
      <div className="relative hidden w-[45%] flex-col items-center justify-center overflow-hidden bg-gradient-to-b from-[#007A85] via-[#00AAB7] to-[#00C4CF] p-12 lg:flex">
        <div
          className="pointer-events-none absolute inset-0 opacity-[0.05]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 15% 25%, #ffffff 0%, transparent 42%), radial-gradient(circle at 85% 75%, #ffffff 0%, transparent 42%)",
          }}
        />
        <div className="relative flex flex-col items-center text-center">
          <img
            src="https://storage.helloreaddy.io/project_files/9818337a-0a98-464f-85b4-cd986046343e/e4d8f675-e586-441e-9438-460bdea9c2ed_compressed_088ef075-be38-4fe0-a96e-7b50a08aee90.webp"
            alt="غسلة"
            className="h-[72px] w-auto object-contain"
          />
          <p className="mt-3 text-sm text-white/60">منصة خدمات النظافة الأولى</p>
        </div>

        <div className="relative mt-10 w-full max-w-[340px] text-center">
          <h2 className="text-[22px] font-bold text-white">{brandTitle}</h2>
          <p className="mt-2 text-sm leading-relaxed text-white/70">{brandSubtitle}</p>
        </div>

        {showHighlights && (
          <div className="relative mt-8 w-full max-w-[340px] space-y-4">
            {[
              "آلاف العملاء ينتظرونك",
              "تحكم كامل بأسعارك وخدماتك",
              "تسويات مالية دورية ومنظمة",
            ].map((item) => (
              <div key={item} className="flex items-center gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/10 text-white">
                  <i className="ri-check-line text-lg" />
                </span>
                <span className="text-sm text-white/85">{item}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Form panel */}
      <div className="flex flex-1 items-center justify-center bg-white p-6 md:p-12">
        <div className="w-full max-w-[420px]">
          <Link
            to="/"
            className="mb-8 inline-flex items-center gap-2 text-sm font-medium text-ghasla-text-link hover:underline lg:hidden"
          >
            <i className="ri-arrow-right-line" />
            العودة
          </Link>

          <div className={centerContent ? "text-center" : ""}>
            <h2 className="text-[26px] font-bold text-ghasla-text-heading">{title}</h2>
            <p className="mt-2 text-sm text-ghasla-text-primary">{subtitle}</p>
          </div>

          <div className="mt-9">{children}</div>
        </div>
      </div>
    </div>
  );
}